<script>
import ApiService from "../utils/ApiService";

export default {
    name: "ModalBillPayments",
    data() {
        return {
            dataList: [],
            loading: true,
            visible: false
        }
    },
    computed: {
        total() {
            return '$' + this.dataList.reduce((sum, item) => {
                return sum + item.Lines.reduce((s, line) => s + line.Amount, 0);
            }, 0).toFixed(2);
        }
    },
    methods: {
        open(billid) {
            this.visible = true;
            this.fetchList(billid);
        },
        close() {
            this.visible = false;
        },
        fetchList(billid) {
            this.loading = true;
            ApiService.get('/buildium/bills/' + billid + '/payments').then(response => {
                this.dataList = response.data;
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<template>
    <el-dialog :title="'Bill Payments (Total: ' + total +')'"
               closeable
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="$emit('input', false)"
    >
        <el-table :data="dataList" v-loading="loading">
            <el-table-column prop="PaidDate" label="Paid Date"/>
            <el-table-column prop="ReferenceNumber" label="Reference Number"/>
            <el-table-column label="Amount">
                <template slot-scope="scope">
                    <div v-for="line in scope.row.Lines||[]">{{ '$' + line.Amount }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Memo">
                <template slot-scope="scope">
                    <div v-for="line in scope.row.Lines||[]">{{ line.Memo }}</div>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<style scoped>

</style>